import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSkillsFilter } from './useSkillsFilter';

export const SkillsFilter = ({ value, setFilters, sharedList, orderBy }) => {
  const { formSchema, onSearchChange, onSubmit } = useSkillsFilter({
    sharedList,
    orderBy,
    setFilters,
  });

  return (
    <Formik
      initialValues={{ skills: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="skills"
          label="Skills"
          placeholder="Search to add"
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SkillsFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
};

SkillsFilter.defaultProps = {
  value: [],
  sharedList: null,
  orderBy: 'count',
};
